import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MainMenu = () => {
  const { t } = useTranslation();

  return (
    <ul>
      {/* Home */}
      <li className="menu-item-has-children">
        <Link to="/">{t('header.menu.home')}</Link>
        <ul className="sub-menu">
          <li><Link to="/">{t('header.menu.home_one')}</Link></li>
          <li><Link to="/home-two">{t('header.menu.home_two')}</Link></li>
        </ul>
      </li>

      {/* About */}
      <li>
        <Link to="/about">{t('header.menu.about')}</Link>
      </li>

      {/* Services */}
      <li className="menu-item-has-children">
        <Link to="/service">{t('header.menu.services')}</Link>
        <ul className="sub-menu">
          <li><Link to="/service">{t('header.menu.service')}</Link></li>
          <li>
            <Link to="/service-details">
              {t('header.menu.service_details')}
            </Link>
          </li>
        </ul>
      </li>

      {/* Pages */}
      <li className="menu-item-has-children">
        <Link to="#">{t('header.menu.pages')}</Link>
        <ul className="sub-menu">
          <li><Link to="/team">{t('header.menu.team')}</Link></li>
          <li>
            <Link to="/team-details">
              {t('header.menu.team_details')}
            </Link>
          </li>
          <li><Link to="/portfolio">{t('header.menu.portfolio')}</Link></li>
          <li>
            <Link to="/portfolio-details">
              {t('header.menu.portfolio_details')}
            </Link>
          </li>
          <li><Link to="/pricing">{t('header.menu.pricing')}</Link></li>
          <li><Link to="/testimonial">{t('header.menu.testimonial')}</Link></li>
          <li><Link to="/faq">{t('header.menu.faq')}</Link></li>
          <li><Link to="/error">{t('header.menu.error')}</Link></li>
        </ul>
      </li>

      {/* Blog */}
      <li className="menu-item-has-children">
        <Link to="/blog">{t('header.menu.blog')}</Link>
        <ul className="sub-menu">
          <li><Link to="/blog">{t('header.menu.blog')}</Link></li>
          <li>
            <Link to="/blog-details">
              {t('header.menu.blog_details')}
            </Link>
          </li>
        </ul>
      </li>

      {/* Contact */}
      <li>
        <Link to="/contact">{t('header.menu.contact')}</Link>
      </li>
    </ul>
  );
};

export default MainMenu;
